import React from 'react'
import { isEmpty } from 'lodash'
import { Container, Alert, bannerStyles } from '@paypalcorp/pp-react'

import { useApplicationContext } from '../../../../../provider'

import './style.css'

const OldNotificationBanner = ({ handleDismiss }) => {
  // Get the user context to see if logged in - we use this to control margin
  const { user, notificationBanner } = useApplicationContext()
  const userLoggedOut = !user?.loggedIn

  const fptiData = typeof window !== `undefined` && window.fpti
  const sendAnalytics = () => {
    if (fptiData) {
      const options = {
        data: {
          page: fptiData.page,
          pgrp: fptiData.pgrp,
          e: 'cl',
          link: `notification-banner-${notificationBanner.link.href}`,
          component: 'devdiscoverynodeweb',
          space_key: 'SKEXJE',
        },
      }

      if (window.PAYPAL?.analytics?.instance) {
        window.PAYPAL?.analytics?.instance?.record(options)
      }
    }
  }

  if (!notificationBanner.enabled || notificationBanner.enabled === 'false') {
    return null
  }

  return (
    <section
      className={
        !userLoggedOut
          ? 'notification-banner notification-banner_loggedIn'
          : 'notification-banner'
      }
    >
      <Container className="banner-wrapper">
        <Alert
          type="info"
          className="alert-banner"
          closeButton={{
            'aria-label': 'dismiss alert',
            onClick: () => handleDismiss(),
          }}
        >
          <span
            dangerouslySetInnerHTML={{ __html: notificationBanner.message }}
          />
          {notificationBanner.link && (
            <a
              href={notificationBanner.link.href}
              rel={notificationBanner.link.rel}
              target={notificationBanner.link.target}
              title={notificationBanner.link.title}
              onClick={sendAnalytics}
            >
              {notificationBanner.link.text}
            </a>
          )}
          <span>{notificationBanner.message_ext}</span>
        </Alert>
      </Container>
    </section>
  )
}

export default OldNotificationBanner
